import { render, staticRenderFns } from "./Malfunction.vue?vue&type=template&id=10ddedaf&scoped=true"
import script from "./Malfunction.vue?vue&type=script&lang=js"
export * from "./Malfunction.vue?vue&type=script&lang=js"
import style0 from "./Malfunction.vue?vue&type=style&index=0&id=10ddedaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ddedaf",
  null
  
)

export default component.exports